// Angular Modules
import { Injectable } from '@angular/core';
import { Http, Response, Headers } from '@angular/http';
// RxJS Modules
import { Observable } from 'rxjs/Observable';

@Injectable()
export class VideoUploadService {
  private uploadUrl: string = window.location.protocol + '//' + window.location.hostname + '/media/videos';

  constructor(
    private http: Http,
  ) { }

  public postVideo(file: File): Observable<any> {
    const videoData = { id: '', location: '' };
    const body = { size: file.size, type: file.type, name: file.name };
    return this.http.post(this.uploadUrl, body)
      .map((res: Response) => {
        const data = res.json();
        const uploadUrl = data.endpoint;
        const form = this.buildForm(data, file);
        const headers = new Headers();
        videoData.id = data.id;
        headers.append('Content-Type', 'multipart/form-data');
        return { uploadUrl, form, headers };
      })
      .flatMap((obj) => this.http.post(obj.uploadUrl, obj.form))
      .map((res: Response) => {
        videoData.location = res.headers.get('location');
        return videoData;
      })
      .flatMap((videoData) => this.finishUpload(videoData.id).map(() => videoData))
      .publishReplay(1).refCount()
      .catch(this.handleError);
  }

  private buildForm(data: any, file: File): FormData {
    const formData: FormData = new FormData();
    formData.append('Content-Type', data.fields['Content-Type']);
    formData.append('bucket', data.fields.bucket);
    formData.append('key', data.fields.key);
    formData.append('policy', data.fields.policy);
    formData.append('x-amz-algorithm', data.fields['x-amz-algorithm']);
    formData.append('x-amz-credential', data.fields['x-amz-credential']);
    formData.append('x-amz-date', data.fields['x-amz-date']);
    formData.append('x-amz-signature', data.fields['x-amz-signature']);

    if (data.fields.acl) {
      formData.append('acl', data.fields.acl);
    }
    if (data.fields['x-amz-security-token']) {
      formData.append('x-amz-security-token', data.fields['x-amz-security-token']);
    }

    // File must be appended last
    formData.append('file', file);

    return formData;
  }

  private finishUpload(videoId: string): Observable<any> {
    const finishUrl = window.location.protocol + '//' + window.location.hostname + `/media/videos/${videoId}/uploaded`;
    return this.http.post(finishUrl, {})
      .map((res: Response) => res.json())
      .catch(this.handleError);
  }

  private handleError(error: any): Promise<any> {
    console.error('An Error Occurred:', error);
    return Promise.reject(error.message || error);
  }
}



// WEBPACK FOOTER //
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/shared/services/video-upload.service.ts